<div class="location-pricing-dialog">
  <header>
    <div class="header-left">
      <h2>Advanced Pricing</h2>
      <div *ngIf="accountName" class="account-name">{{accountName}}</div>
    </div>
    <div class="header-right">
      <div class="close" (click)="close()"></div>
    </div>
  </header>

  <div *ngIf="errors.length > 0" class="error-bar">
    <div *ngFor="let error of errors" class="error">{{error}}</div>
  </div>

  <div *ngIf="loading" class="loading">Loading . . .</div>
  <div *ngIf="loadError" class="error-bar"><div class="error">{{loadError}}</div></div>

  <section *ngIf="!loading && !loadError" class="body">

    <div class="standard-price">
      <div class="standard-price-label">Standard Price</div>
      <div class="standard-price-value">
        {{standardPrice != null ? (standardPrice | rf:'currency') : '—'}}
      </div>
      <div class="standard-price-hint">
        Applies at every location without an alternate price below. Edit it from the product detail.
      </div>
    </div>

    <div class="location-table">
      <div class="table-header">
        <div class="col-location">Location</div>
        <div class="col-price">Alternate Price</div>
        <div class="col-remove"></div>
      </div>

      <div *ngIf="rows.length === 0" class="empty-state">
        No alternate prices yet. Every location uses the standard price.
      </div>

      <div class="table-rows">
      <div *ngFor="let row of rows" class="table-row" [class.removed]="row.removed" [class.new-row]="row.isNew">
        <div class="col-location">
          {{row.locationName}}
          <span *ngIf="row.isNew" class="tag new">New</span>
          <span *ngIf="row.removed" class="tag removed-tag">Will use standard price</span>
        </div>
        <div class="col-price">
          <div class="price-input" [class.invalid]="rowInvalid(row)">
            <span class="currency-symbol">$</span>
            <input type="number" step="0.01" min="0" [(ngModel)]="row.price" [disabled]="row.removed"
                   [placeholder]="standardPrice !== null ? ((standardPrice / 100) | number:'1.2-2') : '0.00'" />
          </div>
          <div *ngIf="rowInvalid(row)" class="field-hint">Price is required</div>
        </div>
        <div class="col-remove">
          <div class="remove-btn" [class.undo]="row.removed" (click)="removeRow(row)"
               [title]="row.removed ? 'Keep this alternate price' : 'Remove this alternate price'">
            <ng-container *ngIf="!row.removed">&#x2715;</ng-container>
            <ng-container *ngIf="row.removed">Undo</ng-container>
          </div>
        </div>
      </div>
      </div>

      <div class="add-row" *ngIf="availableLocations.length > 0">
        <select class="location-select" [ngModel]="addLocationId" (ngModelChange)="addLocation($event)">
          <option value="" disabled>Add a location . . .</option>
          <option *ngFor="let location of availableLocations" [value]="location.locationId">
            {{location.locationName}}
          </option>
        </select>
      </div>
    </div>

  </section>

  <footer *ngIf="!loading && !loadError">
    <button class="button" [disabled]="saving || !hasChanges()" (click)="save()">
      {{saving ? 'Saving . . .' : 'Save'}}
    </button>
  </footer>
</div>
